export function CleanID(text) {
	text = text.replace(/[^A-Z0-9 ]/gi, '');
	text = text.replace(/\ /g, '_');
	text = text.toLowerCase();
	return text;
}

export const cleanString = text => {
	text = text.trim();
	text = text.replace(/(null)/gi, '');
	text = text.replace(/\s\s+/g, ' ');
	text = text.trim();

	try {
		if (text.substr(text.length - 1) === ',') {
			text = text.substring(0, text.length - 1);
		}
	} catch (e) {
		console.log(e);
	}

	return text;
};

export const capitalize = text => {
	let c = '';
	const s = text.split(' ');
	// tslint:disable-next-line
	for (let i = 0; i < s.length; i++) {
		c += s[i].charAt(0).toUpperCase() + s[i].slice(1) + ' ';
	}
	return c;
};

export const wrapIfExceeded = (text, limit = 20) => {
	if (text && text.length > limit) {
		return text.substr(0, limit - 1) + '...';
	} else {
		return text;
	}
};

export const statesList = {
	AL: 'Alabama',
	AK: 'Alaska',
	AZ: 'Arizona',
	AR: 'Arkansas',
	CA: 'California',
	CO: 'Colorado',
	CT: 'Connecticut',
	DE: 'Delaware',
	DC: 'District Of Columbia',
	FL: 'Florida',
	GA: 'Georgia',
	HI: 'Hawaii',
	ID: 'Idaho',
	IL: 'Illinois',
	IN: 'Indiana',
	IA: 'Iowa',
	KS: 'Kansas',
	KY: 'Kentucky',
	LA: 'Louisiana',
	ME: 'Maine',
	MD: 'Maryland',
	MA: 'Massachusetts',
	MI: 'Michigan',
	MN: 'Minnesota',
	MS: 'Mississippi',
	MO: 'Missouri',
	MT: 'Montana',
	NE: 'Nebraska',
	NV: 'Nevada',
	NH: 'New Hampshire',
	NJ: 'New Jersey',
	NM: 'New Mexico',
	NY: 'New York',
	NC: 'North Carolina',
	ND: 'North Dakota',
	OH: 'Ohio',
	OK: 'Oklahoma',
	OR: 'Oregon',
	PA: 'Pennsylvania',
	RI: 'Rhode Island',
	SC: 'South Carolina',
	SD: 'South Dakota',
	TN: 'Tennessee',
	TX: 'Texas',
	UT: 'Utah',
	VT: 'Vermont',
	VI: 'Virgin Islands',
	VA: 'Virginia',
	WA: 'Washington',
	WV: 'West Virginia',
	WI: 'Wisconsin',
	WY: 'Wyoming',
};
